import { RootState } from "../../../../../store";
import { commitmentsSliceSelector } from "../../../commitmentsSliceSelector";

export const utilizationAndCoverageDrawerDatesSelector = (state: RootState) => {
  const slice = commitmentsSliceSelector(state);

  return slice.coverageAndUtilization.detailsDrawer.dates;
};
